import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import axios, { scarifAxios } from "../../../../axios-order";

import "./TDSRecon.css";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ConfirmationDialog from './ConfirmationDailog'
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import EmailIcon from '@mui/icons-material/Email';
import LoadingButton from '@mui/lab/LoadingButton';
import { TextField, Select, MenuItem, InputLabel, FormControl, IconButton, Popover, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Grid, CircularProgress, LinearProgress, Tooltip } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import RemoveIcon from '@mui/icons-material/Remove';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { canWrite } from '../../../../utils/privilegeUtils';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import TuneIcon from '@mui/icons-material/Tune';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import cappiLogo from '../../../../asserts/images/cappi-logo.png';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import HistoryIcon from '@mui/icons-material/History';

const initialPageSize = 1000;
const POLL_INITIAL_DELAY = 15000;
const POLL_MAX_DELAY = 60000;
const POLL_BACKOFF_FACTOR = 1.5;

export default function Form26asreport() {
  let history = useHistory();
  const [form_data, setFormData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [emptyView, setEmptyView] = useState(false)
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [snackbarSeverity, setSnackbarSeverity] = useState("warning");

  const [responseMessage, setResponseMessage] = useState("");

  const [selectedItems, setSelectedItems] = useState([]);

  const [emailButtonLoading, setEmailButtonLoading] = useState(false)

  const [notificationDialogOpen, setNotificationDialogOpen] = useState(false);

  const [searchInput, setSearchInput] = useState('');

  const [filteredData, setFilteredData] = useState([]);

  const [invoiceSelected, setInvoiceSelected] = useState(false)

  const [selectAllChecked, setSelectAllChecked] = useState(false);

  const [filterCondition, setFilterCondition] = useState('greaterThan');
  const [filterValue, setFilterValue] = useState('');

  const [anchorEl, setAnchorEl] = useState(null);

  const [selectAllNotificationLockChecked, setSelectAllNotificationLockChecked] = useState(false);

  const [notificationButtonLoading, setNotificationButtonLoading] = useState(false)
  const [intelligentMatchingOpen, setIntelligentMatchingOpen] = useState(false);
  const [advancedOpen, setAdvancedOpen] = useState(false);
  const [pairingType, setPairingType] = useState('many_to_one');
  const [maxPairsOne, setMaxPairsOne] = useState(5);
  const [maxPairsMany, setMaxPairsMany] = useState(2);
  const [threshold, setThreshold] = useState('');
  // groupBy kept for future use — UI is commented out below, do not remove
  const [groupBy, setGroupBy] = useState('tan');
  const [intelligentMatchingLoading, setIntelligentMatchingLoading] = useState(false);
  const [matchStatus, setMatchStatus] = useState(null);
  const [matchStatusRefreshing, setMatchStatusRefreshing] = useState(false);
  const pollIntervalRef = useRef(null);
  const pollDelayRef = useRef(POLL_INITIAL_DELAY);
  const [unpairCappiDialogOpen, setUnpairCappiDialogOpen] = useState(false);
  const [unpairCappiLoading, setUnpairCappiLoading] = useState(false);
  const [isMappingRunning, setIsMappingRunning] = useState(false);
  const [statsAnchorEl, setStatsAnchorEl] = useState(null);
  const statsCloseTimerRef = useRef(null);
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyData, setHistoryData] = useState([]);

  const handleNotificationRemarkChange = (index, value) => {
    const updatedData = [...filteredData];
    updatedData[index].notification_remarks = value;
    setFilteredData(updatedData);
  };

  const handleNotificationLockChange = (item, isChecked) => {
    const updatedData = filteredData.map(data =>
      data === item ? { ...data, notification_lock: isChecked } : data
    );
    setFilteredData(updatedData);

    // Check if all filtered items are locked to update the Select All checkbox
    setSelectAllNotificationLockChecked(updatedData.every(data => data["Difference"] <= 10 || data.notification_lock));
  };

  const handleSelectAllNotificationLock = (isChecked) => {
    setSelectAllNotificationLockChecked(isChecked);

    const updatedData = filteredData.map(item => ({

      ...item,
      notification_lock: item["Difference"] > 10 ? isChecked : false
    }));

    setFilteredData(updatedData);
  };


  const isPopoverOpen = Boolean(anchorEl);

  const handleSnackbarOpen = (message, severity) => {
    setSnackbarOpen(true);
    setSnackbarSeverity(severity);
    setResponseMessage(message);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  useEffect(() => {
    fetchData();
    checkIsMappingRunning();
  }, []);

  const checkIsMappingRunning = () => {
    scarifAxios
      .get('/recon/is_mapping_running', {
        params: { business_entity_id: localStorage.getItem("business_entity_id") }
      })
      .then((res) => {
        setIsMappingRunning(!!res?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    filterData();
  }, [searchInput]);



  const fetchData = () => {
    setIsLoading(true);
    console.log('use effect calling FECTH DATA ')
    const entity_id = localStorage.getItem("business_entity_id")

    const financial_year = localStorage.getItem('financial_year_26_as')

    const payLoad = {
      'business_entity_id': entity_id,
      'financial_year': financial_year,
      'page_number': currentPage,
      'page_size': initialPageSize,
      'search_text': ''
    }

    axios
      .post('/form_26/get_data', payLoad)
      .then((res) => {
        if (res?.data?.records) {
          // setFormData((prevData) => [...prevData, ...res.data.records]);
          const data = res.data.records
          const allRecordsNotificationLocked = data.every(item =>
            item["Difference"] <= 10 || item.notification_lock
          );
          setSelectAllNotificationLockChecked(allRecordsNotificationLocked)
          setFormData(res.data.records)
          setFilteredData(res.data.records)
          setCurrentPage((prevPage) => prevPage + 1);
          setIsLoading(false);

        } else {
          setEmptyView(true)
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setEmptyView(true)
      });

  };


  const downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const exportToExcel = () => {
    const payloadData = {

      "business_entity_id": localStorage.getItem("business_entity_id"),
      "financial_year": localStorage.getItem('financial_year_26_as')
    }

    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `TDS Receivables Reconciliation Report.xlsx`;

    setIsExporting(true);

    axios.post('/form26asreport_for_table2', payloadData)
      .then((res) => {
        downloadBase64File(contentType, res?.data?.file, filename);
      }).catch((err) => {
      }).finally(() => {
        setIsExporting(false);
      });
  };

  const navigatePairPage = (item, index) => {
    const pairing_data = {
      "business_entity_id": localStorage.getItem("business_entity_id"),
      "books_grouping_key": item.books_grouping_key,
      "books_grouping_type": item.books_grouping_type,
      "form_26as_grouping_key": item.form_26as_grouping_key,
      "grouping_key": item.form_26as_grouping_key,
      "form_26_grouping_type": item.form_26as_grouping_type ? item.form_26as_grouping_type : "",
      "financial_year": localStorage.getItem('financial_year_26_as')
    }
    localStorage.setItem("lastClickedIndex", index);

    history.push({
      pathname: `/26Pairing`,
      state: { pairingData: pairing_data }
    });
  }


  const handleBackFunction = () => {
    history.goBack();
  }

  const handleDialogConfirm = () => {
    const body = {
      business_entity_id: localStorage.getItem("business_entity_id"),
      financial_year: localStorage.getItem('financial_year_26_as')
    }
    axios.post('/form26/unpair_manual_pairs', body)
      .then((res) => {
        if (res.data) {
          handleSnackbarOpen(res.data.message, 'success')
        }
      }).catch((err) => {

      })
  }

  useEffect(() => {
    console.log(invoiceSelected)
  }, [invoiceSelected])

  const onClickSendEmailNotification = () => {
    setEmailButtonLoading(true)
    const pairing_data = {
      "entity_name": localStorage.getItem("entity_name"),
      "business_entity_id": localStorage.getItem("business_entity_id"),
      "financial_year": localStorage.getItem('financial_year_26_as'),
      "selected_items": selectedItems,
      "invoice_details_slected": invoiceSelected
    }
    axios.post('/form26/send_form_26as_report_email', pairing_data)
      .then((res) => {
        setEmailButtonLoading(false)
        setSelectedItems([])
        setSelectAllChecked(false)
        console.log(res.data)
        if (res.data.status) {
          handleSnackbarOpen(res.data.message, "success")
        } else {
          handleSnackbarOpen(res.data.message, "warning")
        }
      })
      .catch((err) => {
        setEmailButtonLoading(false)
        setSelectedItems([])
        setSelectAllChecked(false)
      })
    setInvoiceSelected(false)
  }

  const handleCheckboxChange = (item, isChecked) => {
    setSelectedItems(prevSelectedItems => {
      let newSelectedItems;
      if (isChecked) {
        newSelectedItems = [...prevSelectedItems, item];
      } else {
        newSelectedItems = prevSelectedItems.filter(selectedItem => selectedItem !== item);
      }
      const allItemsSelected = filteredData.filter(item => item["Difference"] > 10 && !item['notification_lock'])
        .every(item => newSelectedItems.includes(item));
      setSelectAllChecked(allItemsSelected);

      return newSelectedItems;
    });
  };


  const handleSelectAll = (isChecked) => {
    setSelectAllChecked(isChecked);
    if (isChecked) {
      const selected = filteredData.filter(item => item["Difference"] > 10 && !item['notification_lock']);
      setSelectedItems(selected);
    } else {
      setSelectedItems([]);
    }
  };


  const handleNoticationClick = () => {
    if (selectedItems.length === 0) {
      setEmailButtonLoading(false)
      handleSnackbarOpen('Please select records to send a notification.', 'warning')
      setSelectAllChecked(false);
      return ''
    } else {
      setNotificationDialogOpen(true)
    }
  }


  const handleSearchEvent = (event) => {
    localStorage.setItem("lastClickedIndex", null);
    const inputValue = event.target.value;
    setSearchInput(inputValue)

  }

  const handleSaveNofticationRemark = () => {
    setNotificationButtonLoading(true);
    const body = {
      business_entity_id: localStorage.getItem("business_entity_id"),
      records: filteredData
    };
    axios.post('/form26/saveNotificationRemark', body)
      .then((res) => {
        const { status, message } = res?.data;
        if (status === true) {
          handleSnackbarOpen(message, "success");
        } else if (status === false) {
          handleSnackbarOpen(message, "warning");
        } else {
          handleSnackbarOpen("Unexpected response from server.", "warning");
        }
      })
      .catch((err) => {
        const message = err?.response?.data?.message || err?.message || "Failed to save. Please try again.";
        handleSnackbarOpen(message, "error");
      })
      .finally(() => {
        setNotificationButtonLoading(false);
      });
  };

  // const handleSaveNofticationRemark = () => {
  //   setNotificationButtonLoading(true)
  //   const body = {
  //     business_entity_id: localStorage.getItem("business_entity_id"),
  //     records: filteredData
  //   }
  //   axios.post('/form26/saveNotificationRemark', body)
  //     .then((res) => {

  //       if (res.data.status) {
  //         handleSnackbarOpen(res.data.message, "success")
  //       } else {
  //         handleSnackbarOpen(res.data.message, "warning")
  //       }

  //     }).catch((err) => {

  //     }).finally(()=>{
  //       setNotificationButtonLoading(false)
  //     })
  // }

  const filterData = () => {
    const filtered = form_data.filter(record => {
      const customerName = record['CUSTOMER NAME'] || '';
      const customerPan = record['CUSTOMER PAN'] || '';
      return customerName.toLowerCase().includes(searchInput.toLowerCase()) ||
        customerPan.toLowerCase().includes(searchInput.toLowerCase());
    });
    setFilteredData(filtered);
  }

  const handleFilterIconClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Function to handle popover close
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleFilterConditionChange = (event) => {
    setFilterCondition(event.target.value);
  };

  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };

  useEffect(() => {
    applyDifferenceFilter();
  }, [filterValue, filterCondition]);


  const applyDifferenceFilter = () => {
    const value = parseFloat(filterValue);

    if (isNaN(value)) {
      setFilteredData(form_data);
      return;
    }

    const filtered = form_data.filter(record => {
      const difference = parseFloat(record["Difference"]);

      if (isNaN(difference)) {
        return false;
      }

      switch (filterCondition) {
        case 'greaterThan':
          return difference > value;
        case 'equalTo':
          return difference === value;
        case 'lessThan':
          return difference < value;
        default:
          return true;
      }
    });

    setFilteredData(filtered);
  };

  const renderDifferenceFilter = () => {
    return (
      <Popover
        open={isPopoverOpen}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            width: '220px', // Set the width to 300px or adjust as needed
            padding: '16px', // Add some padding for better spacing
          },
        }}
      >
        <div>
          <TextField
            label="Value"
            variant="outlined"
            size="small"
            type="number"
            value={filterValue}
            onChange={handleFilterValueChange}
            fullWidth
            style={{ marginBottom: '16px' }}
          />
          {/* Dropdown for condition */}
          <FormControl fullWidth variant="outlined" size="small" >
            <InputLabel>Condition</InputLabel>
            <Select
              value={filterCondition}
              onChange={handleFilterConditionChange}
              label="Condition"
            >
              <MenuItem value="greaterThan">
                <ArrowForwardIcon style={{ marginRight: 8 }} /> Greater Than
              </MenuItem>
              <MenuItem value="equalTo">
                <RemoveIcon style={{ marginRight: 8 }} /> Equal To
              </MenuItem>
              <MenuItem value="lessThan">
                <ArrowBackIcon style={{ marginRight: 8 }} /> Less Than
              </MenuItem>
            </Select>
          </FormControl>

          {/* Input for value */}

        </div>
      </Popover>
    )
  }

  const navigareToExcelPairing = () => {
    history.push({
      pathname: `/26ASExcelParing`
    });
  }

  const handleIntelligentMatchingOpen = () => {
    setIntelligentMatchingOpen(true);
  };

  const handleIntelligentMatchingClose = () => {
    setIntelligentMatchingOpen(false);
    setThreshold('');
    setAdvancedOpen(false);
    setPairingType('many_to_one');
    setMaxPairsOne(5);
    setMaxPairsMany(2);
    setGroupBy('tan');
  };

  const handlePairingTypeChange = (event) => {
    setPairingType(event.target.value);
  };

  const handleMaxPairsOneChange = (event) => {
    setMaxPairsOne(event.target.value);
  };

  const handleMaxPairsManyChange = (event) => {
    setMaxPairsMany(event.target.value);
  };

  const handleThresholdChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]*$/.test(value)) {
      setThreshold(value);
    }
  };

  const handleGroupByChange = (event) => {
    setGroupBy(event.target.value);
  };

  const handleIntelligentMatchingSubmit = () => {
    setIntelligentMatchingLoading(true);

    const basePayload = {
      business_entity_id: localStorage.getItem("business_entity_id"),
      financial_year: localStorage.getItem('financial_year_26_as'),
      threshold_amount: threshold
    };

    let payload = basePayload;

    if (advancedOpen) {
      if (pairingType === 'both') {
        payload = {
          ...basePayload,
          number_of_pairs: maxPairsOne,
          max_m2m_capacity: maxPairsMany,
          mapping_type: 'both'
          // group_by: groupBy, // kept for future use
        };
      } else {
        payload = {
          ...basePayload,
          number_of_pairs: pairingType === 'many_to_one' ? maxPairsOne : maxPairsMany,
          mapping_type: pairingType
          // group_by: groupBy, // kept for future use
        };
      }
    }

    scarifAxios.post('/recon/map_26as_data', payload)
      .then((res) => {
        handleSnackbarOpen(res?.data?.message || 'Intelligent matching completed', 'success');
        setIntelligentMatchingOpen(false);
        fetchData();
        pollDelayRef.current = POLL_INITIAL_DELAY;
        fetchMatchStatus();
      })
      .catch((err) => {
        const message = err?.response?.data?.message || err?.message || 'Failed to run intelligent matching. Please try again.';
        handleSnackbarOpen(message, 'error');
      })
      .finally(() => {
        setIntelligentMatchingLoading(false);
      });
  };

  const handleUnpairCappiMatches = () => {
    setUnpairCappiLoading(true);
    const params = {
      business_entity_id: localStorage.getItem("business_entity_id"),
      financial_year: localStorage.getItem('financial_year_26_as')
    };
    scarifAxios.post('/recon/unpair_intelligent_matches', null, { params })
      .then((res) => {
        handleSnackbarOpen(res?.data?.message || 'Cappi matches unpaired successfully', 'success');
        setUnpairCappiDialogOpen(false);
        fetchData();
        fetchMatchStatus();
      })
      .catch((err) => {
        const message = err?.response?.data?.message || err?.message || 'Failed to unpair Cappi matches. Please try again.';
        handleSnackbarOpen(message, 'error');
      })
      .finally(() => {
        setUnpairCappiLoading(false);
      });
  };

  const scheduleNextStatusPoll = () => {
    if (pollIntervalRef.current) {
      clearTimeout(pollIntervalRef.current);
    }
    pollIntervalRef.current = setTimeout(() => {
      fetchMatchStatus();
    }, pollDelayRef.current);
    pollDelayRef.current = Math.min(pollDelayRef.current * POLL_BACKOFF_FACTOR, POLL_MAX_DELAY);
  };

  const fetchMatchStatus = () => {
    const entity_id = localStorage.getItem("business_entity_id");
    const financial_year_id = localStorage.getItem('financial_year_26_as');

    scarifAxios.get('/recon/map_26as_data/status', {
      params: {
        business_entity_id: entity_id,
        financial_year: financial_year_id
      }
    })
      .then((res) => {
        setMatchStatus(res?.data || null);
        if (res?.data?.status === 'Done' || res?.data?.status === 'Failed') {
          if (pollIntervalRef.current) {
            clearTimeout(pollIntervalRef.current);
            pollIntervalRef.current = null;
          }
          pollDelayRef.current = POLL_INITIAL_DELAY;
        } else if (res?.data?.status === 'Initiated' || res?.data?.status === 'In-Progress') {
          scheduleNextStatusPoll();
        }
      })
      .catch(() => {
      })
      .finally(() => {
        setMatchStatusRefreshing(false);
      });
  };

  const handleMatchStatusRefresh = () => {
    setMatchStatusRefreshing(true);
    fetchMatchStatus();
  };

  const fetchMatchHistory = () => {
    setHistoryLoading(true);
    scarifAxios.get('/recon/map_26as_data/history', {
      params: {
        business_entity_id: localStorage.getItem("business_entity_id"),
        financial_year: localStorage.getItem('financial_year_26_as'),
        count: 10
      }
    })
      .then((res) => {
        setHistoryData(Array.isArray(res?.data) ? res.data : []);
      })
      .catch((err) => {
        const message = err?.response?.data?.message || err?.message || 'Failed to load run history.';
        handleSnackbarOpen(message, 'error');
      })
      .finally(() => {
        setHistoryLoading(false);
      });
  };

  const handleHistoryOpen = () => {
    setHistoryDialogOpen(true);
    fetchMatchHistory();
  };

  useEffect(() => {
    fetchMatchStatus();
    return () => {
      if (pollIntervalRef.current) {
        clearTimeout(pollIntervalRef.current);
      }
    };
  }, []);

  const formatMatchDateTime = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);
    return date.toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  const cancelStatsCloseTimer = () => {
    if (statsCloseTimerRef.current) {
      clearTimeout(statsCloseTimerRef.current);
      statsCloseTimerRef.current = null;
    }
  };

  const handleStatsPopoverOpen = (event) => {
    cancelStatsCloseTimer();
    setStatsAnchorEl(event.currentTarget);
  };

  const handleStatsPopoverKeepOpen = () => {
    cancelStatsCloseTimer();
  };

  const handleStatsPopoverClose = () => {
    cancelStatsCloseTimer();
    statsCloseTimerRef.current = setTimeout(() => {
      setStatsAnchorEl(null);
    }, 250);
  };

  const formatMappedValue = (value) => {
    if (value === null || value === undefined) return '—';
    if (value >= 10000000) return `₹${(value / 10000000).toFixed(2)} Cr`;
    if (value >= 100000) return `₹${(value / 100000).toFixed(2)} L`;
    return `₹${value.toLocaleString('en-IN')}`;
  };

  const formatMappingType = (type) => {
    if (type === 'both') return 'Both (M:1 + M:M)';
    if (type === 'many_to_one') return 'Many to One';
    if (type === 'many_to_many') return 'Many to Many';
    return type || '—';
  };

  const formatGroupByLabel = (field) => {
    if (field === 'tan') return 'TAN';
    if (field === 'cust_pan') return 'PAN';
    return field ? field.toUpperCase() : '—';
  };

  const formatIndianNumber = (value) => {
    if (value === null || value === undefined || value === '') return value;
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const financial_year = localStorage.getItem('financial_year_26_as')

  const isIntelligentMatchingFormIncomplete = !threshold;

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-end', alignItems: 'center', gap: '10px' }}>
        {matchStatus && (
          <div
            onMouseEnter={matchStatus.status === 'Done' ? handleStatsPopoverOpen : undefined}
            onMouseLeave={matchStatus.status === 'Done' ? handleStatsPopoverClose : undefined}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              backgroundColor: matchStatus.status === 'Failed' ? '#fdecea' : matchStatus.status === 'Done' ? '#eafaf1' : '#eef6fc',
              border: `1px solid ${matchStatus.status === 'Failed' ? '#f5c2c0' : matchStatus.status === 'Done' ? '#b7e4c7' : '#bcdff5'}`,
              borderRadius: '8px',
              padding: '6px 12px',
              cursor: matchStatus.status === 'Done' ? 'default' : 'auto'
            }}
          >
            {matchStatus.status === 'Done' && (
              <>
                <CheckCircleIcon style={{ color: '#1eb980', fontSize: 18 }} />
                <Typography variant="body2" style={{ color: '#333', fontSize: '12px' }}>
                  Last matched {formatMatchDateTime(matchStatus.created_at)} • {matchStatus.total_groups} groups
                </Typography>
              </>
            )}
            {matchStatus.status === 'Failed' && (
              <>
                <ErrorIcon style={{ color: '#e53935', fontSize: 18 }} />
                <Typography variant="body2" style={{ color: '#333', fontSize: '12px' }}>
                  Last match failed {formatMatchDateTime(matchStatus.created_at)} • {matchStatus.total_groups} groups
                </Typography>
              </>
            )}
            {(matchStatus.status === 'Initiated' || matchStatus.status === 'In-Progress') && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: '220px' }}>
                <div
                  className="cappi-pulse-dot"
                  style={{
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #6a3df5 0%, #10c4d3 100%)',
                    flexShrink: 0
                  }}
                />
                <div style={{ flex: 1 }}>
                  <Typography variant="body2" style={{ color: '#333', fontSize: '12px', fontWeight: 600, marginBottom: '4px' }}>
                    {matchStatus.status === 'Initiated'
                      ? 'Cappi is getting started…'
                      : `Cappi is matching — ${matchStatus.processed_groups}/${matchStatus.total_groups} groups`}
                  </Typography>
                  <LinearProgress
                    variant={matchStatus.status === 'Initiated' ? 'indeterminate' : 'determinate'}
                    value={matchStatus.total_groups ? (matchStatus.processed_groups / matchStatus.total_groups) * 100 : 0}
                    style={{
                      height: '5px',
                      borderRadius: '4px',
                      backgroundColor: '#dce6f0'
                    }}
                    sx={{
                      '& .MuiLinearProgress-bar': {
                        background: 'linear-gradient(90deg, #6a3df5 0%, #10c4d3 100%)',
                        borderRadius: '4px'
                      }
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        )}

        {matchStatus && matchStatus.status === 'Done' && (
          <Popover
            open={Boolean(statsAnchorEl)}
            anchorEl={statsAnchorEl}
            onClose={() => setStatsAnchorEl(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            disableRestoreFocus
            hideBackdrop
            style={{ pointerEvents: 'none' }}
            PaperProps={{
              style: {
                borderRadius: '14px',
                marginTop: '8px',
                boxShadow: '0 12px 32px rgba(3,64,109,.2)',
                pointerEvents: 'auto',
                overflow: 'visible'
              }
            }}
          >
            <div
              onMouseEnter={handleStatsPopoverKeepOpen}
              onMouseLeave={handleStatsPopoverClose}
              style={{ padding: '18px', width: '300px' }}
            >
              <Typography style={{ fontSize: '11px', fontWeight: 700, color: '#98a2b3', letterSpacing: '0.4px', marginBottom: '12px' }}>
                LAST RUN PERFORMANCE
              </Typography>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '12px' }}>
                <div style={{ backgroundColor: '#eafaf1', borderRadius: '9px', padding: '10px 12px' }}>
                  <div style={{ fontSize: '10.5px', color: '#17966a', fontWeight: 600, marginBottom: '3px' }}>Matched Ratio</div>
                  <div style={{ fontSize: '15px', fontWeight: 700, color: '#182333' }}>{matchStatus.matched_ratio}%</div>
                </div>
                <div style={{ backgroundColor: '#eef6fc', borderRadius: '9px', padding: '10px 12px' }}>
                  <div style={{ fontSize: '10.5px', color: '#03406d', fontWeight: 600, marginBottom: '3px' }}>Paired Value</div>
                  <div style={{ fontSize: '15px', fontWeight: 700, color: '#182333' }}>{formatMappedValue(matchStatus.mapped_value)}</div>
                </div>
                <div style={{ backgroundColor: '#fef6e8', borderRadius: '9px', padding: '10px 12px' }}>
                  <div style={{ fontSize: '10.5px', color: '#b9791a', fontWeight: 600, marginBottom: '3px' }}>Mode</div>
                  <div style={{ fontSize: '13.5px', fontWeight: 700, color: '#182333', lineHeight: 1.3 }}>{formatMappingType(matchStatus.mapping_type)}</div>
                </div>
                <div style={{ backgroundColor: '#f4f0ff', borderRadius: '9px', padding: '10px 12px' }}>
                  <div style={{ fontSize: '10.5px', color: '#6a3df5', fontWeight: 600, marginBottom: '3px' }}>Tolerance</div>
                  <div style={{ fontSize: '15px', fontWeight: 700, color: '#182333' }}>₹{matchStatus.value_adjustment}</div>
                </div>
              </div>
              <Typography style={{ fontSize: '11.5px', color: '#647084', borderTop: '1px solid #e6e9ee', paddingTop: '10px' }}>
                Grouped by {formatGroupByLabel(matchStatus.group_by)} • {matchStatus.unmapped_groups} unmapped groups left for manual review.
              </Typography>
            </div>
          </Popover>
        )}

        <Tooltip
          title={
            (isMappingRunning || (matchStatus && (matchStatus.status === 'Initiated' || matchStatus.status === 'In-Progress')))
              ? "Cappi is already pairing your records — please wait for this run to finish."
              : ''
          }
          arrow
        >
          <span>
            <Button
              variant="contained"
              onClick={handleIntelligentMatchingOpen}
              disabled={isMappingRunning || (matchStatus && (matchStatus.status === 'Initiated' || matchStatus.status === 'In-Progress'))}
              style={{
                background: (isMappingRunning || (matchStatus && (matchStatus.status === 'Initiated' || matchStatus.status === 'In-Progress')))
                  ? '#b0b8c1'
                  : 'linear-gradient(135deg, #6a3df5 0%, #0d6fb8 60%, #10c4d3 100%)',
                color: '#fff',
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: '8px',
                paddingLeft: '18px',
                cursor: (isMappingRunning || (matchStatus && (matchStatus.status === 'Initiated' || matchStatus.status === 'In-Progress'))) ? 'not-allowed' : 'pointer'
              }}
            >
              Pair with Cappi
            </Button>
          </span>
        </Tooltip>
        {canWrite("RECEIVABLES-26AS") && (
          <Tooltip title={(isMappingRunning || (matchStatus && (matchStatus.status === 'Initiated' || matchStatus.status === 'In-Progress'))) ? "Cappi is currently pairing records — please wait for this run to finish." : ''} arrow>
            <span>
              <Button
                endIcon={<AddCircleIcon />}
                color="success"
                variant="contained"
                disabled={isMappingRunning || (matchStatus && (matchStatus.status === 'Initiated' || matchStatus.status === 'In-Progress'))}
                style={{ backgroundColor: (isMappingRunning || (matchStatus && (matchStatus.status === 'Initiated' || matchStatus.status === 'In-Progress'))) ? '#b0b8c1' : '#00c853' }}
                onClick={navigareToExcelPairing}
              >
                Manual Pairing
              </Button>
            </span>
          </Tooltip>
        )}
        <Button
          variant="outlined"
          startIcon={<HistoryIcon />}
          onClick={handleHistoryOpen}
          style={{ borderRadius: '8px', textTransform: 'none', fontWeight: 600, borderColor: '#c7cbd4', color: '#03406d' }}
        >
          History
        </Button>
      </div>
      <BoxWrapper
        enableSearchInput={true}
        searchInputPlaceholder="Search..."
        searchInputOnchange={handleSearchEvent}
        exportToExcelEnable={true}
        exportToExcelFn={exportToExcel}
        loadingexcel={isExporting}
        boxTitle={`26AS Recon - Customer/PAN-wise Summary  ( ${financial_year} )`}>
        <div
          className="responsive-table"
          style={{ scrollbarWidth: "thin", scrollbarHeight: '25px', maxHeight: '52vh' }}
        >
          <table className="summary-tab-single-year-table-css">

            <thead>
              <tr>
                <th style={{ width: process.env.REACT_APP_MODE === "DEBUG" ? "45%" : "22%" }} colSpan={process.env.REACT_APP_MODE === "DEBUG" ? 7 : 3}>
                  Customer Data
                </th>
                <th colSpan={process.env.REACT_APP_MODE === "DEBUG" ? 13 : 11}>
                  TDS Summary
                </th>

                <th rowSpan={2} className="action-column" style={{ width: process.env.REACT_APP_MODE === "DEBUG" ? "4.94%" : "2.95%" }}>Action</th>
              </tr>
              <tr>
                <th>
                  <label style={{ display: 'flex', marginLeft: '25%', cursor: 'pointer' }}>
                    {canWrite("RECEIVABLES-26AS") && filteredData.some(item => item["Difference"] > 10) && (
                      <input
                        type="checkbox"
                        checked={selectAllChecked}
                        disabled={selectAllNotificationLockChecked}
                        onChange={(e) => handleSelectAll(e.target.checked)}
                        style={{
                          width: '20px',
                          height: '20px',
                          backgroundColor: '#fff',
                          border: '2px solid #4CAF50',
                          borderRadius: '5px',
                          cursor: 'pointer'
                        }}
                      />
                    )}
                    <span style={{ marginLeft: '5px' }}>Notification</span>
                  </label>
                </th>



                {process.env.REACT_APP_MODE === "DEBUG" && <th style={{ width: "7%", backgroundColor: '#808080' }}>Grouping Key</th>}
                <th>Customer PAN</th>
                <th>Customer Name</th>
                {process.env.REACT_APP_MODE === "DEBUG" && <th style={{ backgroundColor: '#808080' }} className="customer-name-26as-column">Customer Name 26AS</th>}
                {process.env.REACT_APP_MODE === "DEBUG" && <th style={{ backgroundColor: '#808080' }} className="books-tan-column">Books TAN</th>}
                {process.env.REACT_APP_MODE === "DEBUG" && <th style={{ backgroundColor: '#808080' }} className="form26as-tan-column">26AS TAN</th>}
                <th style={{ width: "5%" }}>Books TDS Opening Balance</th>
                <th style={{ width: "5%" }}>TDS as per Books</th>
                {process.env.REACT_APP_MODE === "DEBUG" && <th style={{ width: "7%", backgroundColor: '#808080' }}>Count of Books records</th>}
                <th style={{ width: "5%" }}>26AS TDS Opening Balance</th>
                <th style={{ width: "5%" }}>TDS as per 26AS</th>
                {process.env.REACT_APP_MODE === "DEBUG" && <th style={{ width: "7%", backgroundColor: '#808080' }}>Count of 26AS records</th>}
                {/* <th style={{ width: "5%" }}>Difference</th> */}
                <th style={{ width: "5%" }}>
                  Difference
                  <IconButton
                    onClick={handleFilterIconClick}
                    size="small"
                    style={{
                      color: filterValue && "#2196F3"
                    }}
                  >
                    <FilterListIcon />
                  </IconButton>
                </th>

                <th style={{ width: "5%" }}>Carry Forward TDS - Books</th>
                <th style={{ width: "5%" }}>Carry Forward TDS - 26AS</th>
                <th style={{ width: "5%" }}>Previous Balance Availed in Current Year - Books</th>
                <th style={{ width: "5%" }}>Previous Balance Availed in Current Year-26AS</th>
                <th rowSpan={2} style={{ width: "25%" }}>Notification Remark</th>
                <th rowSpan={2} style={{ width: "5%" }}>
                  <label style={{ display: 'flex', marginLeft: '18%', cursor: 'pointer' }}>
                    {canWrite("RECEIVABLES-26AS") && filteredData.some(item => item["Difference"] > 10) && (
                      <input
                        type="checkbox"

                        checked={selectAllNotificationLockChecked}
                        onChange={(e) => handleSelectAllNotificationLock(e.target.checked)}
                        style={{
                          width: '20px',
                          height: '20px',
                          backgroundColor: '#fff',
                          border: '2px solid #4CAF50',
                          borderRadius: '5px',
                          cursor: 'pointer'
                        }}
                      />
                    )}
                    <span style={{ marginLeft: '5px' }}>Notification Lock</span>
                  </label>
                </th>
              </tr>


            </thead>
            {renderDifferenceFilter()}
            <tbody>
              {isLoading ? (
                <tr>
                  <td
                    style={{ color: "black", textAlign: 'center', fontWeight: "bold" }}
                    colspan={12}
                  >
                    Loading…Please wait
                  </td>
                </tr>
              ) :

                filteredData.length >= 1 ? (filteredData.map((item, index) => (
                  <tr key={index}>
                    <td>
                      {canWrite("RECEIVABLES-26AS") && item["Difference"] > 10 && (
                        <input type='checkbox'
                          style={{
                            width: '20px',
                            height: '20px',
                            backgroundColor: '#fff',
                            border: '2px solid #4CAF50',
                            borderRadius: '5px',
                            cursor: 'pointer'
                          }}
                          disabled={item['notification_lock']}
                          checked={selectedItems.includes(item)}
                          onChange={(e) => handleCheckboxChange(item, e.target.checked)}
                        />)}
                    </td>
                    {process.env.REACT_APP_MODE === "DEBUG" && <td align="center">{item["books_grouping_key"] ? item["books_grouping_key"] : item["form_26as_grouping_key"]}</td>}
                    <td align="center">{item["CUSTOMER PAN"]}</td>

                    <td>
                      {item["CUSTOMER NAME"] && item["CUSTOMER NAME"].split(", ").map((name, i, arr) => (
                        <React.Fragment key={i}>
                          {name}
                          {i !== arr.length - 1 && <br />}
                        </React.Fragment>
                      ))}
                    </td>
                    {process.env.REACT_APP_MODE === "DEBUG" && <td align="center">{item["customer_name_26AS"]}</td>}
                    {process.env.REACT_APP_MODE === "DEBUG" && <td align="center">
                      {item["books_tan"]}
                    </td>}
                    {process.env.REACT_APP_MODE === "DEBUG" && <td align="center">{item["form26as_tan"]}</td>}
                    <td>{formatIndianNumber(item["Books TDS Opening Balance"])}</td>
                    <td>{formatIndianNumber(item["TDS as per Books"])}</td>
                    {process.env.REACT_APP_MODE === "DEBUG" && <td align="center">{item["count_books_records"]}</td>}
                    <td>{formatIndianNumber(item["26AS TDS Opening Balance"])}</td>
                    <td>{formatIndianNumber(item["TDS as per 26AS"])}</td>
                    {process.env.REACT_APP_MODE === "DEBUG" && <td align="center">{item["count_26as_records"]}</td>}
                    <td>{(item["Difference"] || item["Difference"] == 0) ? formatIndianNumber(item["Difference"]) : ''}</td>
                    <td>{formatIndianNumber(item["Carry Forward TDS - Books"])}</td>
                    <td>{formatIndianNumber(item["Carry Forward TDS - 26AS"])}</td>
                    <td>{formatIndianNumber(item["Previous Balance Availed in Current Year - Books"])}</td>
                    <td>{formatIndianNumber(item["Previous Balance Availed in Current Year - 26AS"])}</td>

                    <td>
                      {canWrite("RECEIVABLES-26AS") && item["Difference"] > 10 && (<textarea
                        value={item.notification_remarks || ''}
                        onChange={(e) => handleNotificationRemarkChange(index, e.target.value)}
                        style={{
                          width: '90%',
                          height: '37px',
                          padding: '7px',
                          margin: '5px 0',
                          border: '1px solid #ccc',
                          borderRadius: '8px',
                          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                          backgroundColor: '#f9f9f9',
                          fontSize: '14px',
                          fontFamily: 'Arial, sans-serif',
                          resize: 'none', // Disable resizing if you want a fixed size
                          overflow: 'hidden', // Remove the scrollbar
                          transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
                        }}
                        placeholder="Enter Remarks"
                        onFocus={(e) => (e.target.style.borderColor = '#4CAF50', e.target.style.boxShadow = '0 0 8px rgba(76, 175, 80, 0.4)')}
                        onBlur={(e) => (e.target.style.borderColor = '#ccc', e.target.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.1)')}
                      />)}
                    </td>


                    {/* New Notification Lock Checkbox */}
                    <td>
                      {canWrite("RECEIVABLES-26AS") && item["Difference"] > 10 && (<input
                        type="checkbox"
                        checked={item.notification_lock || false}
                        onChange={(e) => handleNotificationLockChange(item, e.target.checked)}
                        style={{
                          width: '20px',
                          height: '20px',
                          backgroundColor: '#fff',
                          border: '2px solid #4CAF50',
                          borderRadius: '5px',
                          cursor: 'pointer'
                        }}
                      />)}
                    </td>

                    <td className="action-column" style={{ backgroundColor: '#f2f2f2', border: '1px solid #ddd' }}>

                      <VisibilityOutlinedIcon onClick={() => navigatePairPage(item, index)} className="action-icon-button showIcon" />
                    </td>


                  </tr>
                ))) : (
                  <tr>
                    <td style={{ color: "red" }} colspan={6}>
                      <img src="https://res.cloudinary.com/dyivs1j8u/image/upload/v1713335965/Screenshot_2024-04-17_120750-removebg-preview_tdhay3.png" />
                    </td>
                  </tr>
                )}

            </tbody>

          </table>
        </div>

      </BoxWrapper>
      <div style={{ position: 'fixed', bottom: '20px', right: '20px', display: 'flex', flexDirection: 'row', alignItems: 'flex-end', gap: '10px', marginBottom: '1.3%' }}>
        {canWrite("RECEIVABLES-26AS") && (
          <LoadingButton
            color="primary"
            onClick={handleNoticationClick}
            loading={emailButtonLoading}
            loadingPosition="start"
            startIcon={<EmailIcon />}
            variant="contained"
            style={{ width: '120px', height: '30px' }}
          >
            <span>Send</span>
          </LoadingButton>
        )}

        {canWrite("RECEIVABLES-26AS") && (
          <button
            onClick={() => setDialogOpen(true)}
            className="button-outlined-primary"
            style={{ marginLeft: '0%', width: '180px', marginTop: '20px' }}
          >
            Unpair all Manual Pairs
          </button>
        )}

        <button
          onClick={handleBackFunction}
          className="button-outlined-primary"
          style={{ marginLeft: '0%', width: '120px', marginTop: '20px' }}
        >
          Back
        </button>

        {canWrite("RECEIVABLES-26AS") && (
          <LoadingButton
            color="primary"
            onClick={handleSaveNofticationRemark}
            loading={notificationButtonLoading}
            loadingPosition="start"
            // startIcon={<EmailIcon />}
            variant="contained"
            style={{ width: '120px', height: '30px' }}
          >
            <span>SAVE</span>
          </LoadingButton>
        )}
      </div>

      <ConfirmationDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onConfirm={handleDialogConfirm}
        title={'Confirm Manual Pairs Unpairing'}
        text={`This will remove all manual pairs across all customers. Are you sure you want to proceed?`}
      />

      <ConfirmationDialog
        open={notificationDialogOpen}
        onClose={() => setNotificationDialogOpen(false)}
        onConfirm={onClickSendEmailNotification}
        title="Send Email Notification"
        text="Are you sure you want to send email notifications to the selected customers?"
        enableCheckBox={true}
        checkBoxLable={'Report with invoice details'}
        onChnageInvoiceCheckbox={() => setInvoiceSelected((prev) => !prev)}
      />

      <Dialog
        open={unpairCappiDialogOpen}
        onClose={() => setUnpairCappiDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ style: { borderRadius: '16px', overflow: 'visible' } }}
      >
        <div
          style={{
            background: 'linear-gradient(135deg, #c62828 0%, #f5a623 100%)',
            padding: '22px 28px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px'
          }}
        >
          <ReportProblemOutlinedIcon style={{ color: '#fff', fontSize: 26 }} />
          <Typography variant="h6" style={{ color: '#fff', fontWeight: 700, margin: 0 }}>
            Unpair Cappi Matches
          </Typography>
        </div>

        <DialogContent style={{ padding: '24px 28px' }}>
          <Typography variant="body2" style={{ color: '#666', lineHeight: 1.6 }}>
            This will remove only the pairs Cappi made — your manual pairs stay untouched.
          </Typography>

          <div
            style={{
              marginTop: '20px',
              backgroundColor: '#fdecea',
              borderLeft: '4px solid #c62828',
              borderRadius: '8px',
              padding: '14px 16px',
              display: 'flex',
              alignItems: 'flex-start',
              gap: '10px'
            }}
          >
            <ErrorIcon style={{ color: '#c62828', fontSize: 20, flexShrink: 0, marginTop: '1px' }} />
            <Typography variant="body2" style={{ color: '#555', fontSize: '13.5px', lineHeight: 1.6 }}>
              This action cannot be undone. Are you sure you want to proceed?
            </Typography>
          </div>
        </DialogContent>

        <DialogActions style={{ padding: '18px 28px 24px', backgroundColor: '#fafbfc', borderBottomLeftRadius: '16px', borderBottomRightRadius: '16px' }}>
          <Button
            onClick={() => setUnpairCappiDialogOpen(false)}
            variant="outlined"
            color="primary"
            style={{ borderRadius: '8px', textTransform: 'none', fontWeight: 600 }}
          >
            Cancel
          </Button>
          <LoadingButton
            variant="contained"
            loading={unpairCappiLoading}
            onClick={handleUnpairCappiMatches}
            style={{ backgroundColor: '#c62828', color: '#fff', borderRadius: '8px', textTransform: 'none', fontWeight: 600 }}
          >
            Yes, Unpair
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={historyDialogOpen}
        onClose={() => setHistoryDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ style: { borderRadius: '16px', overflow: 'hidden' } }}
      >
        <div
          style={{
            background: 'linear-gradient(135deg, #03406d 0%, #0d6fb8 100%)',
            padding: '22px 28px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}
        >
          <HistoryIcon style={{ color: '#fff', fontSize: 24 }} />
          <Typography variant="h6" style={{ color: '#fff', fontWeight: 700, margin: 0 }}>
            Pairing History
          </Typography>
        </div>

        <DialogContent style={{ padding: '20px 24px', maxHeight: '480px', overflowY: 'auto' }}>
          {historyLoading ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#647084', fontSize: '13.5px' }}>
              Loading history…
            </div>
          ) : historyData.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#647084', fontSize: '13.5px' }}>
              No previous runs found for this entity and financial year.
            </div>
          ) : (
            historyData.map((run, idx) => (
              <div
                key={run.request_id || idx}
                style={{
                  border: '1px solid #e6e9ee',
                  borderRadius: '12px',
                  padding: '14px 16px',
                  marginBottom: idx === historyData.length - 1 ? 0 : '12px',
                  backgroundColor: '#fafbfd'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                  <Typography style={{ fontSize: '13px', fontWeight: 700, color: '#182333' }}>
                    {formatMatchDateTime(run.created_at)}
                  </Typography>
                  <span
                    style={{
                      fontSize: '11px',
                      fontWeight: 700,
                      padding: '3px 10px',
                      borderRadius: '12px',
                      backgroundColor: run.status === 'Failed' ? '#fdecea' : run.status === 'Done' ? '#eafaf1' : '#eef6fc',
                      color: run.status === 'Failed' ? '#c62828' : run.status === 'Done' ? '#17966a' : '#03406d'
                    }}
                  >
                    {run.status}
                  </span>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' }}>
                  <div>
                    <div style={{ fontSize: '10.5px', color: '#98a2b3', fontWeight: 600 }}>Matched Ratio</div>
                    <div style={{ fontSize: '13.5px', fontWeight: 700, color: '#182333' }}>
                      {run.matched_ratio != null ? `${run.matched_ratio}%` : '—'}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '10.5px', color: '#98a2b3', fontWeight: 600 }}>Paired Value</div>
                    <div style={{ fontSize: '13.5px', fontWeight: 700, color: '#182333' }}>
                      {formatMappedValue(run.mapped_value)}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '10.5px', color: '#98a2b3', fontWeight: 600 }}>Mode</div>
                    <div style={{ fontSize: '13.5px', fontWeight: 700, color: '#182333' }}>
                      {formatMappingType(run.mapping_type)}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '10.5px', color: '#98a2b3', fontWeight: 600 }}>Groups</div>
                    <div style={{ fontSize: '13.5px', fontWeight: 700, color: '#182333' }}>
                      {run.mapped_groups}/{run.total_groups}
                    </div>
                  </div>
                </div>
                <Typography style={{ fontSize: '11.5px', color: '#647084', marginTop: '10px' }}>
                  Grouped by {formatGroupByLabel(run.group_by)} • {run.unmapped_groups} unmapped groups
                </Typography>
              </div>
            ))
          )}
        </DialogContent>

        <DialogActions style={{ padding: '16px 24px 20px', borderTop: '1px solid #e6e9ee' }}>
          <Button
            onClick={() => setHistoryDialogOpen(false)}
            variant="outlined"
            color="primary"
            style={{ borderRadius: '8px', textTransform: 'none', fontWeight: 600 }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={intelligentMatchingOpen}
        onClose={handleIntelligentMatchingClose}
        maxWidth="md"
        fullWidth
        PaperProps={{ style: { borderRadius: '16px', overflow: 'visible', position: 'relative' } }}
      >
        <div
          style={{
            background: 'linear-gradient(135deg, #03406d 0%, #0d6fb8 100%)',
            padding: '22px 28px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px'
          }}
        >
          <AutoAwesomeIcon style={{ color: '#fff', fontSize: 26 }} />
          <Typography variant="h6" style={{ color: '#fff', fontWeight: 700, margin: 0 }}>
            Pair With Cappi
          </Typography>
        </div>

        <div
          className="cappi-peek-badge"
          style={{
            position: 'absolute',
            top: '-28px',
            right: '24px',
            width: '56px',
            height: '56px',
            borderRadius: '50%',
            backgroundColor: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 6px 16px rgba(0,0,0,0.25)',
            padding: '6px',
            pointerEvents: 'none'
          }}
        >
          <img src={cappiLogo} alt="Cappi" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </div>

        <DialogContent style={{ padding: '24px 28px' }}>
          <Typography variant="body2" style={{ color: '#666', marginBottom: '20px', lineHeight: 1.6 }}>
            Let our Cappi automatically pair your records by evaluating thousands of combinations.
          </Typography>

          <Typography style={{ fontWeight: 700, fontSize: '13px', color: '#333', marginBottom: '8px' }}>
            Value Adjustment
          </Typography>
          <TextField
            variant="outlined"
            size="small"
            fullWidth
            placeholder="e.g. 5.00"
            value={threshold}
            onChange={handleThresholdChange}
            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            InputProps={{ style: { borderRadius: '8px' } }}
          />

          <div
            onClick={() => setAdvancedOpen((prev) => !prev)}
            style={{
              marginTop: '18px',
              marginBottom: advancedOpen ? '18px' : '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: '#f7f9fb',
              border: '1px solid #e6e9ee',
              borderRadius: '10px',
              padding: '12px 16px',
              cursor: 'pointer'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div
                style={{
                  width: 26,
                  height: 26,
                  borderRadius: 7,
                  background: 'linear-gradient(135deg, #6a3df5 0%, #10c4d3 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <TuneIcon style={{ color: '#fff', fontSize: 15 }} />
              </div>
              <div>
                <Typography style={{ fontSize: '13.5px', fontWeight: 700, color: '#182333' }}>
                  Advanced options
                </Typography>
                <Typography style={{ fontSize: '11px', color: '#98a2b3' }}>
                  Pairing type &amp; max pairs
                </Typography>
              </div>
            </div>
            <ExpandMoreIcon
              style={{
                color: '#98a2b3',
                transform: advancedOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease'
              }}
            />
          </div>

          {advancedOpen && (
            <div>
              <div style={{ display: 'flex', gap: '14px', marginBottom: '20px' }}>
                <div
                  style={{
                    flex: 1,
                    backgroundColor: '#eef6fc',
                    borderLeft: '4px solid #03406d',
                    borderRadius: '8px',
                    padding: '14px 16px'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                    <CallSplitIcon style={{ color: '#03406d', fontSize: 20 }} />
                    <Typography style={{ fontWeight: 700, fontSize: '14px', color: '#03406d' }}>
                      Pairing Type
                    </Typography>
                  </div>
                  <Typography variant="body2" style={{ color: '#555', fontSize: '13px', lineHeight: 1.5 }}>
                    Choose whether records pair Many to One, Many to Many, or both.
                  </Typography>
                </div>

                <div
                  style={{
                    flex: 1,
                    backgroundColor: '#fef6e8',
                    borderLeft: '4px solid #f5a623',
                    borderRadius: '8px',
                    padding: '14px 16px'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                    <FormatListNumberedIcon style={{ color: '#f5a623', fontSize: 20 }} />
                    <Typography style={{ fontWeight: 700, fontSize: '14px', color: '#b9791a' }}>
                      Max Pairs
                    </Typography>
                  </div>
                  <Typography variant="body2" style={{ color: '#555', fontSize: '13px', lineHeight: 1.5 }}>
                    Sets how many records can be grouped together in a single match.
                  </Typography>
                </div>

                {/*
                <div
                  style={{
                    flex: 1,
                    backgroundColor: '#eafaf1',
                    borderLeft: '4px solid #1eb980',
                    borderRadius: '8px',
                    padding: '14px 16px'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                    <GroupWorkIcon style={{ color: '#1eb980', fontSize: 20 }} />
                    <Typography style={{ fontWeight: 700, fontSize: '14px', color: '#17966a' }}>
                      Group By
                    </Typography>
                  </div>
                  <Typography variant="body2" style={{ color: '#555', fontSize: '13px', lineHeight: 1.5 }}>
                    Chooses which field records are grouped by before matching.
                  </Typography>
                </div>
                */}
              </div>

              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <FormControl fullWidth variant="outlined" size="small">
                    <InputLabel>Pairing Type</InputLabel>
                    <Select
                      value={pairingType}
                      onChange={handlePairingTypeChange}
                      label="Pairing Type"
                      style={{ borderRadius: '8px' }}
                    >
                      <MenuItem value="many_to_one">Many to One</MenuItem>
                      <MenuItem value="many_to_many">Many to Many</MenuItem>
                      <MenuItem value="both">Both</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {pairingType === 'both' ? (
                  <Grid item xs={6}>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel>1:M Max</InputLabel>
                        <Select
                          value={maxPairsOne}
                          onChange={handleMaxPairsOneChange}
                          label="1:M Max"
                          style={{ borderRadius: '8px' }}
                        >
                          {[5, 10, 15, 20, 25, 30].map((num) => (
                            <MenuItem key={num} value={num}>{num}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel>M:M Max</InputLabel>
                        <Select
                          value={maxPairsMany}
                          onChange={handleMaxPairsManyChange}
                          label="M:M Max"
                          style={{ borderRadius: '8px' }}
                        >
                          {[2, 3, 4, 5].map((num) => (
                            <MenuItem key={num} value={num}>{num}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </Grid>
                ) : (
                  <Grid item xs={6}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel>Max No of Pairs</InputLabel>
                      <Select
                        value={pairingType === 'many_to_one' ? maxPairsOne : maxPairsMany}
                        onChange={pairingType === 'many_to_one' ? handleMaxPairsOneChange : handleMaxPairsManyChange}
                        label="Max No of Pairs"
                        style={{ borderRadius: '8px' }}
                      >
                        {(pairingType === 'many_to_one' ? [5, 10, 15, 20, 25, 30] : [2, 3, 4, 5]).map((num) => (
                          <MenuItem key={num} value={num}>{num}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}

                {/*
                <Grid item xs={4}>
                  <FormControl fullWidth variant="outlined" size="small">
                    <InputLabel>Group By</InputLabel>
                    <Select
                      value={groupBy}
                      onChange={handleGroupByChange}
                      label="Group By"
                      style={{ borderRadius: '8px' }}
                    >
                      <MenuItem value="tan">TAN</MenuItem>
                      <MenuItem value="cust_pan">PAN</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                */}
              </Grid>

              <Typography variant="body2" style={{ color: '#98a2b3', fontSize: '11.5px', marginTop: '10px' }}>
                {pairingType === 'many_to_one' && 'Many to One: 5–30, in steps of 5.'}
                {pairingType === 'many_to_many' && 'Many to Many: 2–5.'}
                {pairingType === 'both' && 'Both selected — set a max for each strategy separately, since their valid ranges differ.'}
              </Typography>
            </div>
          )}

          <div
            style={{
              marginTop: '22px',
              backgroundColor: '#fff8e6',
              border: '1px solid #f5a623',
              borderLeft: '5px solid #f5a623',
              borderRadius: '8px',
              padding: '18px 20px',
              boxShadow: '0 2px 6px rgba(245, 166, 35, 0.15)'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
              <TipsAndUpdatesIcon style={{ color: '#b9791a', fontSize: 20 }} />
              <Typography style={{ fontWeight: 700, fontSize: '14px', color: '#b9791a' }}>
                Before You Begin
              </Typography>
            </div>

            {[
              `Records update live as each group is processed, so you may see the data change while pairing
               is in progress. Once processing is complete, the full set of paired records will be available
               for review. Overall progress is visible on the progress bar.`,
              `We only consider records where Remarks-2 is empty. All existing pairs whether made manually or by Cappi are preserved, and we work only with the available (unpaired) data.`,
              `Want to try different combinations? Use "Unpair Cappi Matches" to remove only the pairs Cappi made your manual pairs stay untouched then run this again for fresh results.`
            ].map((point, idx) => (
              <div
                key={idx}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '10px',
                  marginBottom: idx < 2 ? '14px' : 0
                }}
              >
                <span
                  style={{
                    flexShrink: 0,
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    backgroundColor: '#8a94a6',
                    marginTop: '7px'
                  }}
                />
                <Typography variant="body2" style={{ color: '#555', fontSize: '13.5px', lineHeight: 1.6 }}>
                  {point}
                </Typography>
              </div>
            ))}
          </div>
        </DialogContent>

        <DialogActions style={{ padding: '18px 28px 24px', backgroundColor: '#fafbfc', borderBottomLeftRadius: '16px', borderBottomRightRadius: '16px' }}>
          <LoadingButton
            onClick={() => setUnpairCappiDialogOpen(true)}
            variant="outlined"
            color="error"
            loading={unpairCappiLoading}
            style={{ borderRadius: '8px', textTransform: 'none', fontWeight: 600 }}
          >
            Unpair Cappi Matches
          </LoadingButton>
          <Button
            onClick={handleIntelligentMatchingClose}
            variant="outlined"
            color="primary"
            style={{ borderRadius: '8px', textTransform: 'none', fontWeight: 600 }}
          >
            Cancel
          </Button>
          <Tooltip
            title={isIntelligentMatchingFormIncomplete ? "Please fill Value Adjustment to continue." : ''}
            arrow
          >
            <span>
              <LoadingButton
                variant="contained"
                loading={intelligentMatchingLoading}
                disabled={isIntelligentMatchingFormIncomplete}
                onClick={handleIntelligentMatchingSubmit}
                style={{
                  backgroundColor: isIntelligentMatchingFormIncomplete ? '#b0b8c1' : '#03406d',
                  color: '#fff',
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: 600
                }}
              >
                Submit
              </LoadingButton>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>

      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        style={{ maxWidth: '25%' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
        >
          {responseMessage}

        </MuiAlert>
      </Snackbar>
    </div>
  );
}
